var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingapore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_sg_flag"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 24,
    rx: 3,
    ry: 3
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_sg_flag)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 12,
    fill: "#EF3340"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 12.5,
    width: 25,
    height: 12,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7,7) scale(0.7)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 5.5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.8,
    cy: 0,
    r: 4.5,
    fill: "#EF3340"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90) translate(0,-3.3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,-0.9 0.26,-0.28 0.85,-0.28 0.36,0.09 0.55,0.73 0,0.36 -0.55,0.73 -0.36,0.09 -0.85,-0.28 -0.26,-0.28"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-18) translate(0,-3.3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,-0.9 0.26,-0.28 0.85,-0.28 0.36,0.09 0.55,0.73 0,0.36 -0.55,0.73 -0.36,0.09 -0.85,-0.28 -0.26,-0.28"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(54) translate(0,-3.3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,-0.9 0.26,-0.28 0.85,-0.28 0.36,0.09 0.55,0.73 0,0.36 -0.55,0.73 -0.36,0.09 -0.85,-0.28 -0.26,-0.28"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(126) translate(0,-3.3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,-0.9 0.26,-0.28 0.85,-0.28 0.36,0.09 0.55,0.73 0,0.36 -0.55,0.73 -0.36,0.09 -0.85,-0.28 -0.26,-0.28"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(198) translate(0,-3.3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,-0.9 0.26,-0.28 0.85,-0.28 0.36,0.09 0.55,0.73 0,0.36 -0.55,0.73 -0.36,0.09 -0.85,-0.28 -0.26,-0.28"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingapore);
export default __webpack_public_path__ + "static/media/singapore.2f3b28b3ff231da111ff7ec7924c95ad.svg";
export { ForwardRef as ReactComponent };